// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  backend: 'https://online.karoll.bg:8001',
  refreshTokenInterceptorExcludeIndicator: 'https://online.karoll.bg:8001/',
  defaultLanguage: 'bg',
  defaultLocale: 'bg-BG',
  recaptcha: {
    siteKey: '6Le3M6AjAAAAAHaSrhf7XpqjNzO-id72Nf0tiH8M',
  },
  minutesBeforeTokenExpire: 5,
  fileUploadRestrictions: {
    allowedExtensions: ["xls", "pdf", "doc", "docx", "img", "jpg","png", "xlsx"],
    maxFileSize: 20971520
  },
  richTextEditorUrl: 'https://online.karoll.bg/devexpress'
};


/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
